import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BadgePercent, ArrowRight } from "lucide-react";
import { scrollToId } from "./shared";

const LINKS = [
  { label: "Comparison", href: "#comparison", testId: "nav-link-comparison" },
  { label: "Metrics", href: "#metrics", testId: "nav-link-metrics" },
  { label: "Features", href: "#features", testId: "nav-link-features" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "glass-panel border-b" : "border-b border-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-6 px-4 sm:px-6 lg:px-8">
        <button
          data-testid="nav-logo-button"
          onClick={() => scrollToId("#top")}
          className="flex items-center gap-2.5"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-cyan-400/30 bg-cyan-400/10 shadow-[0_0_18px_rgba(34,211,238,0.25)]">
            <BadgePercent className="h-4 w-4 text-cyan-300" />
          </span>
          <span className="font-display text-base font-bold tracking-tight text-white">
            Grab<span className="text-gradient-cyan">Perks</span>
          </span>
        </button>

        <nav className="ml-auto hidden items-center gap-7 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testId}
              onClick={() => scrollToId(l.href)}
              className="group relative text-sm text-slate-400 transition-colors duration-300 hover:text-white"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-gradient-to-r from-blue-500 to-cyan-400 transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-verdict-cta"
          onClick={() => scrollToId("#verdict")}
          className="group ml-auto flex items-center gap-2 rounded-full border border-blue-500/40 bg-blue-500/10 px-3 py-1.5 text-xs font-semibold text-white transition-colors duration-300 hover:border-cyan-400/60 hover:bg-cyan-400/10 sm:px-4 sm:py-2 sm:text-sm md:ml-0"
        >
          Verdict
          <ArrowRight className="h-3.5 w-3.5 text-cyan-300 transition-transform duration-300 group-hover:translate-x-0.5" />
        </button>
      </div>
    </motion.header>
  );
}
